export default __webpack_public_path__ + "static/media/banner10.cf7e41e5.png";